export const GUIDELINE_DEFAULT_COLOR = '#3B82F6'; // global guidelines (blue)
export const GUIDELINE_PAGE_COLOR    = '#22c55e'; // page-specific guidelines (green)

export class Guideline {
  constructor({ id, orientation, position, color = GUIDELINE_DEFAULT_COLOR, pageId = null }) {
    this.id = id;
    this.orientation = orientation; // 'horizontal' | 'vertical'
    this.position = position;       // content-space y (horizontal) or x (vertical)
    this.color = color;
    this.pageId = pageId;           // null = global (all pages), N = page-specific
    this.visible = true;
  }
}
